const React = require("react");
import { any, async, fromJSX, loadingAsyncState, nothing } from "widgets-for-react";
import { fetchRecommendations } from "../../../backendApi/CollectionApi";
import { hasValue } from "../../../utils/asyncState";
import { scrollToTop } from "../../../utils/browser";
import { CollectionJumboWrapper } from "../CollectionJumbo";
import { CollectionItemDetailsLayout } from "./CollectionItemDetailsLayout";
export const CollectionItemDetailsWidget = (props)=>any({
        key: 'CollectionItemDetails'
    })([
        // Render Layout
        fromJSX(()=>{
            if (!hasValue(props.item)) return CollectionJumboWrapper({
                children: React.Fragment
            });
            const item = props.item.value;
            return CollectionItemDetailsLayout({
                ...props,
                item
            });
        }),
        // Manage async state updates
        async(nothing, {
            key: 'collectionItemLoader'
        })(props.item).map((resultUpdater)=>(s0)=>{
                const item = resultUpdater(s0.item);
                let { recommendations } = s0;
                if (item.kind == 'failed') window.location.href = '/niet-gevonden';
                if (s0.item.kind != 'loaded' && item.kind == 'loaded') {
                    recommendations = loadingAsyncState(fetchRecommendations(item.value.Id));
                    scrollToTop();
                }
                return {
                    ...s0,
                    item,
                    recommendations
                };
            }),
        async(nothing, {
            key: 'collectionItemRecommendationsLoader'
        })(props.recommendations).map((resultUpdater)=>(s0)=>{
                const recommendations = resultUpdater(s0.recommendations);
                return {
                    ...s0,
                    recommendations
                };
            })
    ]);
